import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { Title } from 'components/Title';

import GeneralJournal from './GeneralJournal';
export default function GenerajournalPage() {
	
	const [pageReady, setPageReady] = useState(true);
	const [acno, setAcno] = useState('');
const [dateFrom, setDateFrom] = useState('');
const [dateTo, setDateTo] = useState('');
	return (
		<main id="GenerajournalPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col-12 sm:col-12 lg:col-12 md:col-12 comp-grid" >
                <Title title={$t('generajournal')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="sm:col-12 lg:col-4 md:col-4 comp-grid" >
                        <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="single" value={dateFrom}
                        onChange={(e) => setDateFrom(e.value)} placeholder={$t('Date From')}   />
                    </div>
                    <div className="sm:col-12 lg:col-4 md:col-4 comp-grid" >
                        <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="single" value={dateTo}
                        onChange={(e) => setDateTo(e.value)} placeholder={$t('Date To')}   />
                    </div>
                    <div className="sm:col-12 lg:col-4 md:col-4 comp-grid" >
                        <DataSource   apiPath="components_data/ac_code_option_list"  >
                            {({ response }) => {
                            const dropdownOptions = response?.map(x => ({
                            label: x.ac_name || x.label, // adjust field
                            value: String(x.ac_code || x.value) // ensure string
                            })) || [];
                            return (
                            <>
                            <Dropdown
                            name="acno"
                            value={acno}
                            onChange={(e) => setAcno(e.value)}
                            options={dropdownOptions}
                            optionLabel="label"
                            optionValue="value"
                            filter   // 🔍 enables search box
                            showClear
                            placeholder="Select a Loan Account"
                            className="w-500"
                            />
                            </>
                            );
                            }}
                        </DataSource>
                    </div>
                </div>
                <div className="">
                    <div className="">
                        <div className="sm:col-12 lg:col-12 md:col-12 comp-grid" >
                            <div className="">
                                <GeneralJournal dateFrom={dateFrom} dateTo={dateTo} acno={acno} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
